/*
    This will check to see if there are any Plaudit Query Loop elements on the page. If there are it will loop through
    each of them and check their height against the browsers height. If the height is less than the browser, we'll then add the
    .plauditQueryLoop--stickyContent class to the parent (.plauditQueryLoop). When added, this will make the child element
    (.wp-block-post-template) sticky.
*/

const stickyClass = "plauditQueryLoop--stickyContent";

function getQueryLoopElements() {
	return $(".plauditQueryLoop");
}

function updateStickyClass() {
    const viewportHeight = window.innerHeight - 100;
	const queryLoopElements = getQueryLoopElements();

	queryLoopElements.each(function() {
		const child = $(this).find('.wp-block-post-template')[0];

		if (child.offsetHeight < viewportHeight) {
			$(this).addClass(stickyClass);
		} else {
			$(this).removeClass(stickyClass);
		}
	});
}

// Function to set up the MutationObserver
if (getQueryLoopElements().length !== 0) {
	updateStickyClass();

	const observer = new MutationObserver((mutationsList, observer) => {
		updateStickyClass();
	});

	observer.observe(document.body, { attributes: false, childList: true, subtree: true });
}